import type { Clause } from './types';

export function updateClauseContextKind(clause: Clause, contextKind: string): Clause {
  return contextKind === clause.contextKind ? clause : { ...clause, contextKind };
}
